import { IconType, Icons } from "components/icons";
import { ButtonBaseProps } from ".";
import { FC } from "react";
import classNames from "classnames";
import { COLOR_PALETTE } from "theme";

interface props extends ButtonBaseProps {
  iconName: IconType;
}

export const IconButton: FC<props> = (props) => {
  return (
    <button
      type="button"
      {...props.buttonProps}
      className={classNames("btn btn-square shadow-none", {
        "border-0": !props.outlined,
        [`bg-white border-1 border-${props.color}`]: props.outlined,
        [`btn-${props.size}`]: !!props.size,
        [`bg-[${props.backgroundColor}]`]: !!props.backgroundColor,
        [`bg-${props.color}`]:
          !props.outlined && !!props.color && props.color !== "solid",
        [`bg-gray-100`]: !props.color && props.color === "solid",
      })}
    >
      <Icons
        name={props.iconName}
        color={
          props.contentColor ||
          (!props.color || props.color === "solid"
            ? "#BABABA"
            : props.outlined
            ? COLOR_PALETTE[props.color]
            : "#fff")
        }
      />
    </button>
  );
};
